// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file image_processor_service.proto (package cuda_learning, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { AcceleratorType, FilterType, GaussianBlurParameters, GrayscaleType, LibraryCapabilities, ModelInferenceParameters, TraceContext } from "./common_pb.js";

/**
 * @generated from enum cuda_learning.GenericFilterParameterType
 */
export enum GenericFilterParameterType {
  /**
   * @generated from enum value: GENERIC_FILTER_PARAMETER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GENERIC_FILTER_PARAMETER_TYPE_SELECT = 1;
   */
  SELECT = 1,

  /**
   * @generated from enum value: GENERIC_FILTER_PARAMETER_TYPE_RANGE = 2;
   */
  RANGE = 2,

  /**
   * @generated from enum value: GENERIC_FILTER_PARAMETER_TYPE_NUMBER = 3;
   */
  NUMBER = 3,

  /**
   * @generated from enum value: GENERIC_FILTER_PARAMETER_TYPE_CHECKBOX = 4;
   */
  CHECKBOX = 4,

  /**
   * @generated from enum value: GENERIC_FILTER_PARAMETER_TYPE_TEXT = 5;
   */
  TEXT = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(GenericFilterParameterType)
proto3.util.setEnumType(GenericFilterParameterType, "cuda_learning.GenericFilterParameterType", [
  { no: 0, name: "GENERIC_FILTER_PARAMETER_TYPE_UNSPECIFIED" },
  { no: 1, name: "GENERIC_FILTER_PARAMETER_TYPE_SELECT" },
  { no: 2, name: "GENERIC_FILTER_PARAMETER_TYPE_RANGE" },
  { no: 3, name: "GENERIC_FILTER_PARAMETER_TYPE_NUMBER" },
  { no: 4, name: "GENERIC_FILTER_PARAMETER_TYPE_CHECKBOX" },
  { no: 5, name: "GENERIC_FILTER_PARAMETER_TYPE_TEXT" },
]);

/**
 * @generated from enum cuda_learning.CapturedImageFormat
 */
export enum CapturedImageFormat {
  /**
   * treated as PNG
   *
   * @generated from enum value: CAPTURED_IMAGE_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CAPTURED_IMAGE_FORMAT_PNG = 1;
   */
  PNG = 1,

  /**
   * @generated from enum value: CAPTURED_IMAGE_FORMAT_BMP = 2;
   */
  BMP = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(CapturedImageFormat)
proto3.util.setEnumType(CapturedImageFormat, "cuda_learning.CapturedImageFormat", [
  { no: 0, name: "CAPTURED_IMAGE_FORMAT_UNSPECIFIED" },
  { no: 1, name: "CAPTURED_IMAGE_FORMAT_PNG" },
  { no: 2, name: "CAPTURED_IMAGE_FORMAT_BMP" },
]);

/**
 * ControlRequest is the envelope sent from the browser to the C++ accelerator
 * over the WebRTC "control" data channel. Each request carries a unique
 * request_id so the response can be correlated.
 *
 * @generated from message cuda_learning.ControlRequest
 */
export class ControlRequest extends Message<ControlRequest> {
  /**
   * @generated from field: string request_id = 1 [json_name = "request_id"];
   */
  requestId = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 2 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  /**
   * @generated from oneof cuda_learning.ControlRequest.payload
   */
  payload: {
    /**
     * @generated from field: cuda_learning.ListFiltersRequest list_filters = 10 [json_name = "list_filters"];
     */
    value: ListFiltersRequest;
    case: "listFilters";
  } | {
    /**
     * @generated from field: cuda_learning.GetVersionInfoRequest get_version = 11 [json_name = "get_version"];
     */
    value: GetVersionInfoRequest;
    case: "getVersion";
  } | {
    /**
     * @generated from field: cuda_learning.GetAcceleratorCapabilitiesRequest get_accelerator_capabilities = 12 [json_name = "get_accelerator_capabilities"];
     */
    value: GetAcceleratorCapabilitiesRequest;
    case: "getAcceleratorCapabilities";
  } | {
    /**
     * @generated from field: cuda_learning.StartCameraStreamRequest start_camera_stream = 13 [json_name = "start_camera_stream"];
     */
    value: StartCameraStreamRequest;
    case: "startCameraStream";
  } | {
    /**
     * @generated from field: cuda_learning.StopCameraStreamRequest stop_camera_stream = 14 [json_name = "stop_camera_stream"];
     */
    value: StopCameraStreamRequest;
    case: "stopCameraStream";
  } | {
    /**
     * @generated from field: cuda_learning.CaptureFrameRequest capture_frame = 15 [json_name = "capture_frame"];
     */
    value: CaptureFrameRequest;
    case: "captureFrame";
  } | {
    /**
     * @generated from field: cuda_learning.ListCapturedImagesRequest list_captured_images = 16 [json_name = "list_captured_images"];
     */
    value: ListCapturedImagesRequest;
    case: "listCapturedImages";
  } | {
    /**
     * @generated from field: cuda_learning.GetCapturedImageRequest get_captured_image = 17 [json_name = "get_captured_image"];
     */
    value: GetCapturedImageRequest;
    case: "getCapturedImage";
  } | {
    /**
     * @generated from field: cuda_learning.DeleteCapturedImageRequest delete_captured_image = 18 [json_name = "delete_captured_image"];
     */
    value: DeleteCapturedImageRequest;
    case: "deleteCapturedImage";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ControlRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ControlRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "request_id", jsonName: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
    { no: 10, name: "list_filters", jsonName: "list_filters", kind: "message", T: ListFiltersRequest, oneof: "payload" },
    { no: 11, name: "get_version", jsonName: "get_version", kind: "message", T: GetVersionInfoRequest, oneof: "payload" },
    { no: 12, name: "get_accelerator_capabilities", jsonName: "get_accelerator_capabilities", kind: "message", T: GetAcceleratorCapabilitiesRequest, oneof: "payload" },
    { no: 13, name: "start_camera_stream", jsonName: "start_camera_stream", kind: "message", T: StartCameraStreamRequest, oneof: "payload" },
    { no: 14, name: "stop_camera_stream", jsonName: "stop_camera_stream", kind: "message", T: StopCameraStreamRequest, oneof: "payload" },
    { no: 15, name: "capture_frame", jsonName: "capture_frame", kind: "message", T: CaptureFrameRequest, oneof: "payload" },
    { no: 16, name: "list_captured_images", jsonName: "list_captured_images", kind: "message", T: ListCapturedImagesRequest, oneof: "payload" },
    { no: 17, name: "get_captured_image", jsonName: "get_captured_image", kind: "message", T: GetCapturedImageRequest, oneof: "payload" },
    { no: 18, name: "delete_captured_image", jsonName: "delete_captured_image", kind: "message", T: DeleteCapturedImageRequest, oneof: "payload" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ControlRequest {
    return new ControlRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ControlRequest {
    return new ControlRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ControlRequest {
    return new ControlRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ControlRequest | PlainMessage<ControlRequest> | undefined, b: ControlRequest | PlainMessage<ControlRequest> | undefined): boolean {
    return proto3.util.equals(ControlRequest, a, b);
  }
}

/**
 * ControlResponse is the C++ accelerator's reply on the WebRTC "control" data
 * channel. The request_id mirrors the originating ControlRequest.
 *
 * @generated from message cuda_learning.ControlResponse
 */
export class ControlResponse extends Message<ControlResponse> {
  /**
   * @generated from field: string request_id = 1 [json_name = "request_id"];
   */
  requestId = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 2 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  /**
   * @generated from oneof cuda_learning.ControlResponse.payload
   */
  payload: {
    /**
     * @generated from field: cuda_learning.ListFiltersResponse list_filters = 10 [json_name = "list_filters"];
     */
    value: ListFiltersResponse;
    case: "listFilters";
  } | {
    /**
     * @generated from field: cuda_learning.GetVersionInfoResponse get_version = 11 [json_name = "get_version"];
     */
    value: GetVersionInfoResponse;
    case: "getVersion";
  } | {
    /**
     * @generated from field: cuda_learning.GetAcceleratorCapabilitiesResponse get_accelerator_capabilities = 12 [json_name = "get_accelerator_capabilities"];
     */
    value: GetAcceleratorCapabilitiesResponse;
    case: "getAcceleratorCapabilities";
  } | {
    /**
     * @generated from field: cuda_learning.StartCameraStreamResponse start_camera_stream = 13 [json_name = "start_camera_stream"];
     */
    value: StartCameraStreamResponse;
    case: "startCameraStream";
  } | {
    /**
     * @generated from field: cuda_learning.StopCameraStreamResponse stop_camera_stream = 14 [json_name = "stop_camera_stream"];
     */
    value: StopCameraStreamResponse;
    case: "stopCameraStream";
  } | {
    /**
     * @generated from field: cuda_learning.CaptureFrameResponse capture_frame = 15 [json_name = "capture_frame"];
     */
    value: CaptureFrameResponse;
    case: "captureFrame";
  } | {
    /**
     * @generated from field: cuda_learning.ListCapturedImagesResponse list_captured_images = 16 [json_name = "list_captured_images"];
     */
    value: ListCapturedImagesResponse;
    case: "listCapturedImages";
  } | {
    /**
     * @generated from field: cuda_learning.GetCapturedImageResponse get_captured_image = 17 [json_name = "get_captured_image"];
     */
    value: GetCapturedImageResponse;
    case: "getCapturedImage";
  } | {
    /**
     * @generated from field: cuda_learning.DeleteCapturedImageResponse delete_captured_image = 18 [json_name = "delete_captured_image"];
     */
    value: DeleteCapturedImageResponse;
    case: "deleteCapturedImage";
  } | {
    /**
     * @generated from field: cuda_learning.ControlError error = 99;
     */
    value: ControlError;
    case: "error";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ControlResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ControlResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "request_id", jsonName: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
    { no: 10, name: "list_filters", jsonName: "list_filters", kind: "message", T: ListFiltersResponse, oneof: "payload" },
    { no: 11, name: "get_version", jsonName: "get_version", kind: "message", T: GetVersionInfoResponse, oneof: "payload" },
    { no: 12, name: "get_accelerator_capabilities", jsonName: "get_accelerator_capabilities", kind: "message", T: GetAcceleratorCapabilitiesResponse, oneof: "payload" },
    { no: 13, name: "start_camera_stream", jsonName: "start_camera_stream", kind: "message", T: StartCameraStreamResponse, oneof: "payload" },
    { no: 14, name: "stop_camera_stream", jsonName: "stop_camera_stream", kind: "message", T: StopCameraStreamResponse, oneof: "payload" },
    { no: 15, name: "capture_frame", jsonName: "capture_frame", kind: "message", T: CaptureFrameResponse, oneof: "payload" },
    { no: 16, name: "list_captured_images", jsonName: "list_captured_images", kind: "message", T: ListCapturedImagesResponse, oneof: "payload" },
    { no: 17, name: "get_captured_image", jsonName: "get_captured_image", kind: "message", T: GetCapturedImageResponse, oneof: "payload" },
    { no: 18, name: "delete_captured_image", jsonName: "delete_captured_image", kind: "message", T: DeleteCapturedImageResponse, oneof: "payload" },
    { no: 99, name: "error", kind: "message", T: ControlError, oneof: "payload" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ControlResponse {
    return new ControlResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ControlResponse {
    return new ControlResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ControlResponse {
    return new ControlResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ControlResponse | PlainMessage<ControlResponse> | undefined, b: ControlResponse | PlainMessage<ControlResponse> | undefined): boolean {
    return proto3.util.equals(ControlResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.ControlError
 */
export class ControlError extends Message<ControlError> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  constructor(data?: PartialMessage<ControlError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ControlError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ControlError {
    return new ControlError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ControlError {
    return new ControlError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ControlError {
    return new ControlError().fromJsonString(jsonString, options);
  }

  static equals(a: ControlError | PlainMessage<ControlError> | undefined, b: ControlError | PlainMessage<ControlError> | undefined): boolean {
    return proto3.util.equals(ControlError, a, b);
  }
}

/**
 * @generated from message cuda_learning.GenericFilterParameterOption
 */
export class GenericFilterParameterOption extends Message<GenericFilterParameterOption> {
  /**
   * @generated from field: string value = 1;
   */
  value = "";

  /**
   * @generated from field: string label = 3;
   */
  label = "";

  constructor(data?: PartialMessage<GenericFilterParameterOption>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GenericFilterParameterOption";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenericFilterParameterOption {
    return new GenericFilterParameterOption().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenericFilterParameterOption {
    return new GenericFilterParameterOption().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenericFilterParameterOption {
    return new GenericFilterParameterOption().fromJsonString(jsonString, options);
  }

  static equals(a: GenericFilterParameterOption | PlainMessage<GenericFilterParameterOption> | undefined, b: GenericFilterParameterOption | PlainMessage<GenericFilterParameterOption> | undefined): boolean {
    return proto3.util.equals(GenericFilterParameterOption, a, b);
  }
}

/**
 * @generated from message cuda_learning.GenericFilterParameter
 */
export class GenericFilterParameter extends Message<GenericFilterParameter> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: cuda_learning.GenericFilterParameterType type = 5;
   */
  type = GenericFilterParameterType.UNSPECIFIED;

  /**
   * @generated from field: repeated cuda_learning.GenericFilterParameterOption options = 7;
   */
  options: GenericFilterParameterOption[] = [];

  /**
   * @generated from field: string default_value = 9 [json_name = "default_value"];
   */
  defaultValue = "";

  /**
   * @generated from field: map<string, string> metadata = 11;
   */
  metadata: { [key: string]: string } = {};

  /**
   * @generated from field: bool required = 13;
   */
  required = false;

  /**
   * @generated from field: double min_value = 15 [json_name = "min_value"];
   */
  minValue = 0;

  /**
   * @generated from field: double max_value = 17 [json_name = "max_value"];
   */
  maxValue = 0;

  /**
   * @generated from field: double step = 19;
   */
  step = 0;

  /**
   * @generated from field: uint32 min_items = 21 [json_name = "min_items"];
   */
  minItems = 0;

  /**
   * @generated from field: uint32 max_items = 23 [json_name = "max_items"];
   */
  maxItems = 0;

  /**
   * @generated from field: string pattern = 25;
   */
  pattern = "";

  constructor(data?: PartialMessage<GenericFilterParameter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GenericFilterParameter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "type", kind: "enum", T: proto3.getEnumType(GenericFilterParameterType) },
    { no: 7, name: "options", kind: "message", T: GenericFilterParameterOption, repeated: true },
    { no: 9, name: "default_value", jsonName: "default_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 13, name: "required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "min_value", jsonName: "min_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 17, name: "max_value", jsonName: "max_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 19, name: "step", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 21, name: "min_items", jsonName: "min_items", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 23, name: "max_items", jsonName: "max_items", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 25, name: "pattern", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenericFilterParameter {
    return new GenericFilterParameter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenericFilterParameter {
    return new GenericFilterParameter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenericFilterParameter {
    return new GenericFilterParameter().fromJsonString(jsonString, options);
  }

  static equals(a: GenericFilterParameter | PlainMessage<GenericFilterParameter> | undefined, b: GenericFilterParameter | PlainMessage<GenericFilterParameter> | undefined): boolean {
    return proto3.util.equals(GenericFilterParameter, a, b);
  }
}

/**
 * @generated from message cuda_learning.GenericFilterDefinition
 */
export class GenericFilterDefinition extends Message<GenericFilterDefinition> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: repeated cuda_learning.GenericFilterParameter parameters = 5;
   */
  parameters: GenericFilterParameter[] = [];

  /**
   * @generated from field: repeated cuda_learning.AcceleratorType supported_accelerators = 7 [json_name = "supported_accelerators"];
   */
  supportedAccelerators: AcceleratorType[] = [];

  constructor(data?: PartialMessage<GenericFilterDefinition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GenericFilterDefinition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "parameters", kind: "message", T: GenericFilterParameter, repeated: true },
    { no: 7, name: "supported_accelerators", jsonName: "supported_accelerators", kind: "enum", T: proto3.getEnumType(AcceleratorType), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenericFilterDefinition {
    return new GenericFilterDefinition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenericFilterDefinition {
    return new GenericFilterDefinition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenericFilterDefinition {
    return new GenericFilterDefinition().fromJsonString(jsonString, options);
  }

  static equals(a: GenericFilterDefinition | PlainMessage<GenericFilterDefinition> | undefined, b: GenericFilterDefinition | PlainMessage<GenericFilterDefinition> | undefined): boolean {
    return proto3.util.equals(GenericFilterDefinition, a, b);
  }
}

/**
 * @generated from message cuda_learning.GenericFilterParameterSelection
 */
export class GenericFilterParameterSelection extends Message<GenericFilterParameterSelection> {
  /**
   * @generated from field: string parameter_id = 1 [json_name = "parameter_id"];
   */
  parameterId = "";

  /**
   * @generated from field: repeated string values = 3;
   */
  values: string[] = [];

  constructor(data?: PartialMessage<GenericFilterParameterSelection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GenericFilterParameterSelection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "parameter_id", jsonName: "parameter_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenericFilterParameterSelection {
    return new GenericFilterParameterSelection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenericFilterParameterSelection {
    return new GenericFilterParameterSelection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenericFilterParameterSelection {
    return new GenericFilterParameterSelection().fromJsonString(jsonString, options);
  }

  static equals(a: GenericFilterParameterSelection | PlainMessage<GenericFilterParameterSelection> | undefined, b: GenericFilterParameterSelection | PlainMessage<GenericFilterParameterSelection> | undefined): boolean {
    return proto3.util.equals(GenericFilterParameterSelection, a, b);
  }
}

/**
 * @generated from message cuda_learning.GenericFilterSelection
 */
export class GenericFilterSelection extends Message<GenericFilterSelection> {
  /**
   * @generated from field: string filter_id = 1 [json_name = "filter_id"];
   */
  filterId = "";

  /**
   * @generated from field: repeated cuda_learning.GenericFilterParameterSelection parameters = 3;
   */
  parameters: GenericFilterParameterSelection[] = [];

  constructor(data?: PartialMessage<GenericFilterSelection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GenericFilterSelection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filter_id", jsonName: "filter_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parameters", kind: "message", T: GenericFilterParameterSelection, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenericFilterSelection {
    return new GenericFilterSelection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenericFilterSelection {
    return new GenericFilterSelection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenericFilterSelection {
    return new GenericFilterSelection().fromJsonString(jsonString, options);
  }

  static equals(a: GenericFilterSelection | PlainMessage<GenericFilterSelection> | undefined, b: GenericFilterSelection | PlainMessage<GenericFilterSelection> | undefined): boolean {
    return proto3.util.equals(GenericFilterSelection, a, b);
  }
}

/**
 * @generated from message cuda_learning.ListFiltersRequest
 */
export class ListFiltersRequest extends Message<ListFiltersRequest> {
  /**
   * @generated from field: string api_version = 1 [json_name = "api_version"];
   */
  apiVersion = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 3 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  /**
   * When set, returns only filters supported by this accelerator.
   * When UNSPECIFIED (0), returns all filters across all accelerators.
   *
   * @generated from field: cuda_learning.AcceleratorType requested_accelerator = 5 [json_name = "requested_accelerator"];
   */
  requestedAccelerator = AcceleratorType.UNSPECIFIED;

  constructor(data?: PartialMessage<ListFiltersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ListFiltersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
    { no: 5, name: "requested_accelerator", jsonName: "requested_accelerator", kind: "enum", T: proto3.getEnumType(AcceleratorType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFiltersRequest {
    return new ListFiltersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFiltersRequest {
    return new ListFiltersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFiltersRequest {
    return new ListFiltersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFiltersRequest | PlainMessage<ListFiltersRequest> | undefined, b: ListFiltersRequest | PlainMessage<ListFiltersRequest> | undefined): boolean {
    return proto3.util.equals(ListFiltersRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.ListFiltersResponse
 */
export class ListFiltersResponse extends Message<ListFiltersResponse> {
  /**
   * @generated from field: repeated cuda_learning.GenericFilterDefinition filters = 1;
   */
  filters: GenericFilterDefinition[] = [];

  /**
   * @generated from field: string api_version = 3 [json_name = "api_version"];
   */
  apiVersion = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 5 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<ListFiltersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ListFiltersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filters", kind: "message", T: GenericFilterDefinition, repeated: true },
    { no: 3, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFiltersResponse {
    return new ListFiltersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFiltersResponse {
    return new ListFiltersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFiltersResponse {
    return new ListFiltersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFiltersResponse | PlainMessage<ListFiltersResponse> | undefined, b: ListFiltersResponse | PlainMessage<ListFiltersResponse> | undefined): boolean {
    return proto3.util.equals(ListFiltersResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.GetAcceleratorCapabilitiesRequest
 */
export class GetAcceleratorCapabilitiesRequest extends Message<GetAcceleratorCapabilitiesRequest> {
  constructor(data?: PartialMessage<GetAcceleratorCapabilitiesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GetAcceleratorCapabilitiesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAcceleratorCapabilitiesRequest {
    return new GetAcceleratorCapabilitiesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAcceleratorCapabilitiesRequest {
    return new GetAcceleratorCapabilitiesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAcceleratorCapabilitiesRequest {
    return new GetAcceleratorCapabilitiesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAcceleratorCapabilitiesRequest | PlainMessage<GetAcceleratorCapabilitiesRequest> | undefined, b: GetAcceleratorCapabilitiesRequest | PlainMessage<GetAcceleratorCapabilitiesRequest> | undefined): boolean {
    return proto3.util.equals(GetAcceleratorCapabilitiesRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.AcceleratorOption
 */
export class AcceleratorOption extends Message<AcceleratorOption> {
  /**
   * @generated from field: cuda_learning.AcceleratorType type = 1;
   */
  type = AcceleratorType.UNSPECIFIED;

  /**
   * @generated from field: string label = 2;
   */
  label = "";

  constructor(data?: PartialMessage<AcceleratorOption>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.AcceleratorOption";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(AcceleratorType) },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AcceleratorOption {
    return new AcceleratorOption().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AcceleratorOption {
    return new AcceleratorOption().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AcceleratorOption {
    return new AcceleratorOption().fromJsonString(jsonString, options);
  }

  static equals(a: AcceleratorOption | PlainMessage<AcceleratorOption> | undefined, b: AcceleratorOption | PlainMessage<AcceleratorOption> | undefined): boolean {
    return proto3.util.equals(AcceleratorOption, a, b);
  }
}

/**
 * @generated from message cuda_learning.GetAcceleratorCapabilitiesResponse
 */
export class GetAcceleratorCapabilitiesResponse extends Message<GetAcceleratorCapabilitiesResponse> {
  /**
   * @generated from field: string device_id = 1 [json_name = "device_id"];
   */
  deviceId = "";

  /**
   * @generated from field: string display_name = 2 [json_name = "display_name"];
   */
  displayName = "";

  /**
   * @generated from field: repeated cuda_learning.AcceleratorOption supported_options = 3 [json_name = "supported_options"];
   */
  supportedOptions: AcceleratorOption[] = [];

  /**
   * @generated from field: string version = 4;
   */
  version = "";

  constructor(data?: PartialMessage<GetAcceleratorCapabilitiesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GetAcceleratorCapabilitiesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "device_id", jsonName: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", jsonName: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "supported_options", jsonName: "supported_options", kind: "message", T: AcceleratorOption, repeated: true },
    { no: 4, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAcceleratorCapabilitiesResponse {
    return new GetAcceleratorCapabilitiesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAcceleratorCapabilitiesResponse {
    return new GetAcceleratorCapabilitiesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAcceleratorCapabilitiesResponse {
    return new GetAcceleratorCapabilitiesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAcceleratorCapabilitiesResponse | PlainMessage<GetAcceleratorCapabilitiesResponse> | undefined, b: GetAcceleratorCapabilitiesResponse | PlainMessage<GetAcceleratorCapabilitiesResponse> | undefined): boolean {
    return proto3.util.equals(GetAcceleratorCapabilitiesResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.KeepaliveRequest
 */
export class KeepaliveRequest extends Message<KeepaliveRequest> {
  /**
   * @generated from field: string session_id = 1 [json_name = "session_id"];
   */
  sessionId = "";

  /**
   * @generated from field: string api_version = 3 [json_name = "api_version"];
   */
  apiVersion = "";

  constructor(data?: PartialMessage<KeepaliveRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.KeepaliveRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", jsonName: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KeepaliveRequest {
    return new KeepaliveRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KeepaliveRequest {
    return new KeepaliveRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KeepaliveRequest {
    return new KeepaliveRequest().fromJsonString(jsonString, options);
  }

  static equals(a: KeepaliveRequest | PlainMessage<KeepaliveRequest> | undefined, b: KeepaliveRequest | PlainMessage<KeepaliveRequest> | undefined): boolean {
    return proto3.util.equals(KeepaliveRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.DataChannelRequest
 */
export class DataChannelRequest extends Message<DataChannelRequest> {
  /**
   * @generated from oneof cuda_learning.DataChannelRequest.payload
   */
  payload: {
    /**
     * @generated from field: cuda_learning.ProcessImageRequest process_image = 1 [json_name = "process_image"];
     */
    value: ProcessImageRequest;
    case: "processImage";
  } | {
    /**
     * @generated from field: cuda_learning.KeepaliveRequest keepalive = 3;
     */
    value: KeepaliveRequest;
    case: "keepalive";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<DataChannelRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.DataChannelRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "process_image", jsonName: "process_image", kind: "message", T: ProcessImageRequest, oneof: "payload" },
    { no: 3, name: "keepalive", kind: "message", T: KeepaliveRequest, oneof: "payload" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DataChannelRequest {
    return new DataChannelRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DataChannelRequest {
    return new DataChannelRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DataChannelRequest {
    return new DataChannelRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DataChannelRequest | PlainMessage<DataChannelRequest> | undefined, b: DataChannelRequest | PlainMessage<DataChannelRequest> | undefined): boolean {
    return proto3.util.equals(DataChannelRequest, a, b);
  }
}

/**
 * Request: Go passes raw image buffer
 *
 * @generated from message cuda_learning.ProcessImageRequest
 */
export class ProcessImageRequest extends Message<ProcessImageRequest> {
  /**
   * @generated from field: bytes image_data = 1 [json_name = "image_data"];
   */
  imageData = new Uint8Array(0);

  /**
   * @generated from field: int32 width = 3;
   */
  width = 0;

  /**
   * @generated from field: int32 height = 5;
   */
  height = 0;

  /**
   * @generated from field: int32 channels = 7;
   */
  channels = 0;

  /**
   * @generated from field: repeated cuda_learning.FilterType filters = 9;
   */
  filters: FilterType[] = [];

  /**
   * @generated from field: cuda_learning.AcceleratorType accelerator = 11;
   */
  accelerator = AcceleratorType.UNSPECIFIED;

  /**
   * @generated from field: cuda_learning.GrayscaleType grayscale_type = 13 [json_name = "grayscale_type"];
   */
  grayscaleType = GrayscaleType.UNSPECIFIED;

  /**
   * @generated from field: cuda_learning.GaussianBlurParameters blur_params = 25 [json_name = "blur_params"];
   */
  blurParams?: GaussianBlurParameters;

  /**
   * @generated from field: repeated cuda_learning.GenericFilterSelection generic_filters = 27 [json_name = "generic_filters"];
   */
  genericFilters: GenericFilterSelection[] = [];

  /**
   * @generated from field: string session_id = 29 [json_name = "session_id"];
   */
  sessionId = "";

  /**
   * @generated from field: cuda_learning.ModelInferenceParameters model_params = 31 [json_name = "model_params"];
   */
  modelParams?: ModelInferenceParameters;

  /**
   * @generated from field: uint64 frame_id = 33 [json_name = "frame_id"];
   */
  frameId = protoInt64.zero;

  /**
   * OpenTelemetry trace context propagation (deprecated - use trace_context instead)
   *
   * @generated from field: string trace_id = 15 [json_name = "trace_id"];
   */
  traceId = "";

  /**
   * @generated from field: string span_id = 17 [json_name = "span_id"];
   */
  spanId = "";

  /**
   * @generated from field: uint32 trace_flags = 19 [json_name = "trace_flags"];
   */
  traceFlags = 0;

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 21 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  /**
   * @generated from field: string api_version = 23 [json_name = "api_version"];
   */
  apiVersion = "";

  constructor(data?: PartialMessage<ProcessImageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ProcessImageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "image_data", jsonName: "image_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "channels", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "filters", kind: "enum", T: proto3.getEnumType(FilterType), repeated: true },
    { no: 11, name: "accelerator", kind: "enum", T: proto3.getEnumType(AcceleratorType) },
    { no: 13, name: "grayscale_type", jsonName: "grayscale_type", kind: "enum", T: proto3.getEnumType(GrayscaleType) },
    { no: 25, name: "blur_params", jsonName: "blur_params", kind: "message", T: GaussianBlurParameters },
    { no: 27, name: "generic_filters", jsonName: "generic_filters", kind: "message", T: GenericFilterSelection, repeated: true },
    { no: 29, name: "session_id", jsonName: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "model_params", jsonName: "model_params", kind: "message", T: ModelInferenceParameters },
    { no: 33, name: "frame_id", jsonName: "frame_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 15, name: "trace_id", jsonName: "trace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "span_id", jsonName: "span_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "trace_flags", jsonName: "trace_flags", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 21, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
    { no: 23, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProcessImageRequest {
    return new ProcessImageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProcessImageRequest {
    return new ProcessImageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProcessImageRequest {
    return new ProcessImageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ProcessImageRequest | PlainMessage<ProcessImageRequest> | undefined, b: ProcessImageRequest | PlainMessage<ProcessImageRequest> | undefined): boolean {
    return proto3.util.equals(ProcessImageRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.Detection
 */
export class Detection extends Message<Detection> {
  /**
   * @generated from field: float x = 1;
   */
  x = 0;

  /**
   * @generated from field: float y = 2;
   */
  y = 0;

  /**
   * @generated from field: float width = 3;
   */
  width = 0;

  /**
   * @generated from field: float height = 4;
   */
  height = 0;

  /**
   * @generated from field: int32 class_id = 5 [json_name = "class_id"];
   */
  classId = 0;

  /**
   * @generated from field: string class_name = 6 [json_name = "class_name"];
   */
  className = "";

  /**
   * @generated from field: float confidence = 7;
   */
  confidence = 0;

  constructor(data?: PartialMessage<Detection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.Detection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "x", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "y", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "width", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "height", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "class_id", jsonName: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "class_name", jsonName: "class_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Detection {
    return new Detection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Detection {
    return new Detection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Detection {
    return new Detection().fromJsonString(jsonString, options);
  }

  static equals(a: Detection | PlainMessage<Detection> | undefined, b: Detection | PlainMessage<Detection> | undefined): boolean {
    return proto3.util.equals(Detection, a, b);
  }
}

/**
 * Response: C++ returns processed image buffer
 *
 * @generated from message cuda_learning.ProcessImageResponse
 */
export class ProcessImageResponse extends Message<ProcessImageResponse> {
  /**
   * @generated from field: int32 code = 1;
   */
  code = 0;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: bytes image_data = 5 [json_name = "image_data"];
   */
  imageData = new Uint8Array(0);

  /**
   * @generated from field: int32 width = 7;
   */
  width = 0;

  /**
   * @generated from field: int32 height = 9;
   */
  height = 0;

  /**
   * @generated from field: int32 channels = 11;
   */
  channels = 0;

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 13 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  /**
   * @generated from field: string api_version = 15 [json_name = "api_version"];
   */
  apiVersion = "";

  /**
   * @generated from field: repeated cuda_learning.Detection detections = 17;
   */
  detections: Detection[] = [];

  /**
   * @generated from field: uint64 frame_id = 19 [json_name = "frame_id"];
   */
  frameId = protoInt64.zero;

  constructor(data?: PartialMessage<ProcessImageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ProcessImageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "image_data", jsonName: "image_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 7, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "channels", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
    { no: 15, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "detections", kind: "message", T: Detection, repeated: true },
    { no: 19, name: "frame_id", jsonName: "frame_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProcessImageResponse {
    return new ProcessImageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProcessImageResponse {
    return new ProcessImageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProcessImageResponse {
    return new ProcessImageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ProcessImageResponse | PlainMessage<ProcessImageResponse> | undefined, b: ProcessImageResponse | PlainMessage<ProcessImageResponse> | undefined): boolean {
    return proto3.util.equals(ProcessImageResponse, a, b);
  }
}

/**
 * Lightweight message sent on the detection WebRTC DataChannel
 *
 * @generated from message cuda_learning.DetectionFrame
 */
export class DetectionFrame extends Message<DetectionFrame> {
  /**
   * @generated from field: uint64 frame_id = 1 [json_name = "frame_id"];
   */
  frameId = protoInt64.zero;

  /**
   * @generated from field: repeated cuda_learning.Detection detections = 2;
   */
  detections: Detection[] = [];

  /**
   * @generated from field: int32 image_width = 3 [json_name = "image_width"];
   */
  imageWidth = 0;

  /**
   * @generated from field: int32 image_height = 4 [json_name = "image_height"];
   */
  imageHeight = 0;

  constructor(data?: PartialMessage<DetectionFrame>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.DetectionFrame";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "frame_id", jsonName: "frame_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "detections", kind: "message", T: Detection, repeated: true },
    { no: 3, name: "image_width", jsonName: "image_width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "image_height", jsonName: "image_height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DetectionFrame {
    return new DetectionFrame().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DetectionFrame {
    return new DetectionFrame().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DetectionFrame {
    return new DetectionFrame().fromJsonString(jsonString, options);
  }

  static equals(a: DetectionFrame | PlainMessage<DetectionFrame> | undefined, b: DetectionFrame | PlainMessage<DetectionFrame> | undefined): boolean {
    return proto3.util.equals(DetectionFrame, a, b);
  }
}

/**
 * @generated from message cuda_learning.MetricValue
 */
export class MetricValue extends Message<MetricValue> {
  /**
   * @generated from oneof cuda_learning.MetricValue.value
   */
  value: {
    /**
     * @generated from field: double double_value = 1 [json_name = "double_value"];
     */
    value: number;
    case: "doubleValue";
  } | {
    /**
     * @generated from field: int64 int64_value = 2 [json_name = "int64_value"];
     */
    value: bigint;
    case: "int64Value";
  } | {
    /**
     * @generated from field: string string_value = 3 [json_name = "string_value"];
     */
    value: string;
    case: "stringValue";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<MetricValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.MetricValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "double_value", jsonName: "double_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, oneof: "value" },
    { no: 2, name: "int64_value", jsonName: "int64_value", kind: "scalar", T: 3 /* ScalarType.INT64 */, oneof: "value" },
    { no: 3, name: "string_value", jsonName: "string_value", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetricValue {
    return new MetricValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetricValue {
    return new MetricValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetricValue {
    return new MetricValue().fromJsonString(jsonString, options);
  }

  static equals(a: MetricValue | PlainMessage<MetricValue> | undefined, b: MetricValue | PlainMessage<MetricValue> | undefined): boolean {
    return proto3.util.equals(MetricValue, a, b);
  }
}

/**
 * @generated from message cuda_learning.MetricPoint
 */
export class MetricPoint extends Message<MetricPoint> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: cuda_learning.MetricValue value = 2;
   */
  value?: MetricValue;

  /**
   * @generated from field: string unit = 3;
   */
  unit = "";

  /**
   * @generated from field: map<string, string> tags = 4;
   */
  tags: { [key: string]: string } = {};

  constructor(data?: PartialMessage<MetricPoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.MetricPoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "message", T: MetricValue },
    { no: 3, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tags", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetricPoint {
    return new MetricPoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetricPoint {
    return new MetricPoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetricPoint {
    return new MetricPoint().fromJsonString(jsonString, options);
  }

  static equals(a: MetricPoint | PlainMessage<MetricPoint> | undefined, b: MetricPoint | PlainMessage<MetricPoint> | undefined): boolean {
    return proto3.util.equals(MetricPoint, a, b);
  }
}

/**
 * @generated from message cuda_learning.ProcessingStatsFrame
 */
export class ProcessingStatsFrame extends Message<ProcessingStatsFrame> {
  /**
   * @generated from field: string session_id = 1 [json_name = "session_id"];
   */
  sessionId = "";

  /**
   * @generated from field: uint64 frame_id = 2 [json_name = "frame_id"];
   */
  frameId = protoInt64.zero;

  /**
   * @generated from field: int64 capture_ts_unix_ms = 3 [json_name = "capture_ts_unix_ms"];
   */
  captureTsUnixMs = protoInt64.zero;

  /**
   * @generated from field: repeated cuda_learning.MetricPoint metrics = 4;
   */
  metrics: MetricPoint[] = [];

  constructor(data?: PartialMessage<ProcessingStatsFrame>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ProcessingStatsFrame";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", jsonName: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "frame_id", jsonName: "frame_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "capture_ts_unix_ms", jsonName: "capture_ts_unix_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "metrics", kind: "message", T: MetricPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProcessingStatsFrame {
    return new ProcessingStatsFrame().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProcessingStatsFrame {
    return new ProcessingStatsFrame().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProcessingStatsFrame {
    return new ProcessingStatsFrame().fromJsonString(jsonString, options);
  }

  static equals(a: ProcessingStatsFrame | PlainMessage<ProcessingStatsFrame> | undefined, b: ProcessingStatsFrame | PlainMessage<ProcessingStatsFrame> | undefined): boolean {
    return proto3.util.equals(ProcessingStatsFrame, a, b);
  }
}

/**
 * Lifecycle management
 *
 * @generated from message cuda_learning.InitRequest
 */
export class InitRequest extends Message<InitRequest> {
  /**
   * @generated from field: int32 cuda_device_id = 1;
   */
  cudaDeviceId = 0;

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 3 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  /**
   * @generated from field: string api_version = 5 [json_name = "api_version"];
   */
  apiVersion = "";

  constructor(data?: PartialMessage<InitRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.InitRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cuda_device_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
    { no: 5, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitRequest {
    return new InitRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitRequest {
    return new InitRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitRequest {
    return new InitRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InitRequest | PlainMessage<InitRequest> | undefined, b: InitRequest | PlainMessage<InitRequest> | undefined): boolean {
    return proto3.util.equals(InitRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.InitResponse
 */
export class InitResponse extends Message<InitResponse> {
  /**
   * @generated from field: int32 code = 1;
   */
  code = 0;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 5 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  /**
   * @generated from field: string api_version = 7 [json_name = "api_version"];
   */
  apiVersion = "";

  constructor(data?: PartialMessage<InitResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.InitResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
    { no: 7, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitResponse {
    return new InitResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitResponse {
    return new InitResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitResponse {
    return new InitResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InitResponse | PlainMessage<InitResponse> | undefined, b: InitResponse | PlainMessage<InitResponse> | undefined): boolean {
    return proto3.util.equals(InitResponse, a, b);
  }
}

/**
 * Capabilities query (internal use)
 *
 * @generated from message cuda_learning.GetCapabilitiesRequest
 */
export class GetCapabilitiesRequest extends Message<GetCapabilitiesRequest> {
  /**
   * @generated from field: string api_version = 1 [json_name = "api_version"];
   */
  apiVersion = "";

  constructor(data?: PartialMessage<GetCapabilitiesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GetCapabilitiesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCapabilitiesRequest {
    return new GetCapabilitiesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCapabilitiesRequest {
    return new GetCapabilitiesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCapabilitiesRequest {
    return new GetCapabilitiesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCapabilitiesRequest | PlainMessage<GetCapabilitiesRequest> | undefined, b: GetCapabilitiesRequest | PlainMessage<GetCapabilitiesRequest> | undefined): boolean {
    return proto3.util.equals(GetCapabilitiesRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.GetCapabilitiesResponse
 */
export class GetCapabilitiesResponse extends Message<GetCapabilitiesResponse> {
  /**
   * @generated from field: int32 code = 1;
   */
  code = 0;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: cuda_learning.LibraryCapabilities capabilities = 5;
   */
  capabilities?: LibraryCapabilities;

  constructor(data?: PartialMessage<GetCapabilitiesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GetCapabilitiesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "capabilities", kind: "message", T: LibraryCapabilities },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCapabilitiesResponse {
    return new GetCapabilitiesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCapabilitiesResponse {
    return new GetCapabilitiesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCapabilitiesResponse {
    return new GetCapabilitiesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCapabilitiesResponse | PlainMessage<GetCapabilitiesResponse> | undefined, b: GetCapabilitiesResponse | PlainMessage<GetCapabilitiesResponse> | undefined): boolean {
    return proto3.util.equals(GetCapabilitiesResponse, a, b);
  }
}

/**
 * Version information query
 *
 * @generated from message cuda_learning.GetVersionInfoRequest
 */
export class GetVersionInfoRequest extends Message<GetVersionInfoRequest> {
  /**
   * @generated from field: string api_version = 1 [json_name = "api_version"];
   */
  apiVersion = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 3 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<GetVersionInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GetVersionInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVersionInfoRequest {
    return new GetVersionInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVersionInfoRequest {
    return new GetVersionInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVersionInfoRequest {
    return new GetVersionInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetVersionInfoRequest | PlainMessage<GetVersionInfoRequest> | undefined, b: GetVersionInfoRequest | PlainMessage<GetVersionInfoRequest> | undefined): boolean {
    return proto3.util.equals(GetVersionInfoRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.GetVersionInfoResponse
 */
export class GetVersionInfoResponse extends Message<GetVersionInfoResponse> {
  /**
   * @generated from field: int32 code = 1;
   */
  code = 0;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: string server_version = 5 [json_name = "server_version"];
   */
  serverVersion = "";

  /**
   * @generated from field: string library_version = 7 [json_name = "library_version"];
   */
  libraryVersion = "";

  /**
   * @generated from field: string build_date = 9 [json_name = "build_date"];
   */
  buildDate = "";

  /**
   * @generated from field: string build_commit = 11 [json_name = "build_commit"];
   */
  buildCommit = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 13 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  /**
   * @generated from field: string api_version = 15 [json_name = "api_version"];
   */
  apiVersion = "";

  constructor(data?: PartialMessage<GetVersionInfoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GetVersionInfoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "server_version", jsonName: "server_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "library_version", jsonName: "library_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "build_date", jsonName: "build_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "build_commit", jsonName: "build_commit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
    { no: 15, name: "api_version", jsonName: "api_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVersionInfoResponse {
    return new GetVersionInfoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVersionInfoResponse {
    return new GetVersionInfoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVersionInfoResponse {
    return new GetVersionInfoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetVersionInfoResponse | PlainMessage<GetVersionInfoResponse> | undefined, b: GetVersionInfoResponse | PlainMessage<GetVersionInfoResponse> | undefined): boolean {
    return proto3.util.equals(GetVersionInfoResponse, a, b);
  }
}

/**
 * StartCameraStreamRequest is sent by the browser over the WebRTC control
 * data channel to instruct the C++ accelerator to begin capturing a local
 * camera sensor and push processed video on the outbound video track.
 *
 * @generated from message cuda_learning.StartCameraStreamRequest
 */
export class StartCameraStreamRequest extends Message<StartCameraStreamRequest> {
  /**
   * @generated from field: int32 sensor_id = 1 [json_name = "sensor_id"];
   */
  sensorId = 0;

  /**
   * @generated from field: int32 width = 2;
   */
  width = 0;

  /**
   * @generated from field: int32 height = 3;
   */
  height = 0;

  /**
   * @generated from field: int32 fps = 4;
   */
  fps = 0;

  constructor(data?: PartialMessage<StartCameraStreamRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.StartCameraStreamRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sensor_id", jsonName: "sensor_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "fps", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartCameraStreamRequest {
    return new StartCameraStreamRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartCameraStreamRequest {
    return new StartCameraStreamRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartCameraStreamRequest {
    return new StartCameraStreamRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartCameraStreamRequest | PlainMessage<StartCameraStreamRequest> | undefined, b: StartCameraStreamRequest | PlainMessage<StartCameraStreamRequest> | undefined): boolean {
    return proto3.util.equals(StartCameraStreamRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.StartCameraStreamResponse
 */
export class StartCameraStreamResponse extends Message<StartCameraStreamResponse> {
  /**
   * @generated from field: bool accepted = 1;
   */
  accepted = false;

  /**
   * @generated from field: string reason = 2;
   */
  reason = "";

  constructor(data?: PartialMessage<StartCameraStreamResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.StartCameraStreamResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "accepted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartCameraStreamResponse {
    return new StartCameraStreamResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartCameraStreamResponse {
    return new StartCameraStreamResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartCameraStreamResponse {
    return new StartCameraStreamResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartCameraStreamResponse | PlainMessage<StartCameraStreamResponse> | undefined, b: StartCameraStreamResponse | PlainMessage<StartCameraStreamResponse> | undefined): boolean {
    return proto3.util.equals(StartCameraStreamResponse, a, b);
  }
}

/**
 * StopCameraStreamRequest halts the camera capture for this WebRTC session.
 *
 * @generated from message cuda_learning.StopCameraStreamRequest
 */
export class StopCameraStreamRequest extends Message<StopCameraStreamRequest> {
  constructor(data?: PartialMessage<StopCameraStreamRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.StopCameraStreamRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StopCameraStreamRequest {
    return new StopCameraStreamRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StopCameraStreamRequest {
    return new StopCameraStreamRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StopCameraStreamRequest {
    return new StopCameraStreamRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StopCameraStreamRequest | PlainMessage<StopCameraStreamRequest> | undefined, b: StopCameraStreamRequest | PlainMessage<StopCameraStreamRequest> | undefined): boolean {
    return proto3.util.equals(StopCameraStreamRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.StopCameraStreamResponse
 */
export class StopCameraStreamResponse extends Message<StopCameraStreamResponse> {
  /**
   * @generated from field: bool stopped = 1;
   */
  stopped = false;

  constructor(data?: PartialMessage<StopCameraStreamResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.StopCameraStreamResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stopped", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StopCameraStreamResponse {
    return new StopCameraStreamResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StopCameraStreamResponse {
    return new StopCameraStreamResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StopCameraStreamResponse {
    return new StopCameraStreamResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StopCameraStreamResponse | PlainMessage<StopCameraStreamResponse> | undefined, b: StopCameraStreamResponse | PlainMessage<StopCameraStreamResponse> | undefined): boolean {
    return proto3.util.equals(StopCameraStreamResponse, a, b);
  }
}

/**
 * CaptureFrameRequest instructs the accelerator to save the next processed
 * output frame as a BMP file under its captures directory.
 *
 * @generated from message cuda_learning.CaptureFrameRequest
 */
export class CaptureFrameRequest extends Message<CaptureFrameRequest> {
  constructor(data?: PartialMessage<CaptureFrameRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.CaptureFrameRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CaptureFrameRequest {
    return new CaptureFrameRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CaptureFrameRequest {
    return new CaptureFrameRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CaptureFrameRequest {
    return new CaptureFrameRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CaptureFrameRequest | PlainMessage<CaptureFrameRequest> | undefined, b: CaptureFrameRequest | PlainMessage<CaptureFrameRequest> | undefined): boolean {
    return proto3.util.equals(CaptureFrameRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.CaptureFrameResponse
 */
export class CaptureFrameResponse extends Message<CaptureFrameResponse> {
  /**
   * @generated from field: bool captured = 1;
   */
  captured = false;

  /**
   * @generated from field: string filename = 2;
   */
  filename = "";

  /**
   * @generated from field: string reason = 3;
   */
  reason = "";

  constructor(data?: PartialMessage<CaptureFrameResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.CaptureFrameResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "captured", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CaptureFrameResponse {
    return new CaptureFrameResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CaptureFrameResponse {
    return new CaptureFrameResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CaptureFrameResponse {
    return new CaptureFrameResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CaptureFrameResponse | PlainMessage<CaptureFrameResponse> | undefined, b: CaptureFrameResponse | PlainMessage<CaptureFrameResponse> | undefined): boolean {
    return proto3.util.equals(CaptureFrameResponse, a, b);
  }
}

/**
 * ListCapturedImages returns a paginated list of BMP files saved by CaptureFrame.
 *
 * @generated from message cuda_learning.ListCapturedImagesRequest
 */
export class ListCapturedImagesRequest extends Message<ListCapturedImagesRequest> {
  /**
   * 0-indexed
   *
   * @generated from field: int32 page = 1;
   */
  page = 0;

  /**
   * default 20 when 0
   *
   * @generated from field: int32 page_size = 2 [json_name = "page_size"];
   */
  pageSize = 0;

  constructor(data?: PartialMessage<ListCapturedImagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ListCapturedImagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", jsonName: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCapturedImagesRequest {
    return new ListCapturedImagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCapturedImagesRequest {
    return new ListCapturedImagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCapturedImagesRequest {
    return new ListCapturedImagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCapturedImagesRequest | PlainMessage<ListCapturedImagesRequest> | undefined, b: ListCapturedImagesRequest | PlainMessage<ListCapturedImagesRequest> | undefined): boolean {
    return proto3.util.equals(ListCapturedImagesRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.CapturedImageInfo
 */
export class CapturedImageInfo extends Message<CapturedImageInfo> {
  /**
   * filename stem, e.g. capture_20260501_143022_456
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * with .bmp extension
   *
   * @generated from field: string filename = 2;
   */
  filename = "";

  /**
   * Unix ms from file mtime
   *
   * @generated from field: int64 captured_at_ms = 3 [json_name = "captured_at_ms"];
   */
  capturedAtMs = protoInt64.zero;

  constructor(data?: PartialMessage<CapturedImageInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.CapturedImageInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "captured_at_ms", jsonName: "captured_at_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CapturedImageInfo {
    return new CapturedImageInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CapturedImageInfo {
    return new CapturedImageInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CapturedImageInfo {
    return new CapturedImageInfo().fromJsonString(jsonString, options);
  }

  static equals(a: CapturedImageInfo | PlainMessage<CapturedImageInfo> | undefined, b: CapturedImageInfo | PlainMessage<CapturedImageInfo> | undefined): boolean {
    return proto3.util.equals(CapturedImageInfo, a, b);
  }
}

/**
 * @generated from message cuda_learning.ListCapturedImagesResponse
 */
export class ListCapturedImagesResponse extends Message<ListCapturedImagesResponse> {
  /**
   * @generated from field: repeated cuda_learning.CapturedImageInfo images = 1;
   */
  images: CapturedImageInfo[] = [];

  /**
   * @generated from field: int32 total_count = 2 [json_name = "total_count"];
   */
  totalCount = 0;

  /**
   * @generated from field: bool has_more = 3 [json_name = "has_more"];
   */
  hasMore = false;

  constructor(data?: PartialMessage<ListCapturedImagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.ListCapturedImagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "images", kind: "message", T: CapturedImageInfo, repeated: true },
    { no: 2, name: "total_count", jsonName: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "has_more", jsonName: "has_more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCapturedImagesResponse {
    return new ListCapturedImagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCapturedImagesResponse {
    return new ListCapturedImagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCapturedImagesResponse {
    return new ListCapturedImagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCapturedImagesResponse | PlainMessage<ListCapturedImagesResponse> | undefined, b: ListCapturedImagesResponse | PlainMessage<ListCapturedImagesResponse> | undefined): boolean {
    return proto3.util.equals(ListCapturedImagesResponse, a, b);
  }
}

/**
 * GetCapturedImage fetches a single captured image as PNG (thumbnail) or BMP (download).
 *
 * @generated from message cuda_learning.GetCapturedImageRequest
 */
export class GetCapturedImageRequest extends Message<GetCapturedImageRequest> {
  /**
   * filename stem
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * thumbnail bound (0 = full-res, PNG only)
   *
   * @generated from field: int32 max_width = 2 [json_name = "max_width"];
   */
  maxWidth = 0;

  /**
   * thumbnail bound (0 = full-res, PNG only)
   *
   * @generated from field: int32 max_height = 3 [json_name = "max_height"];
   */
  maxHeight = 0;

  /**
   * UNSPECIFIED/PNG = display; BMP = download
   *
   * @generated from field: cuda_learning.CapturedImageFormat format = 4;
   */
  format = CapturedImageFormat.UNSPECIFIED;

  constructor(data?: PartialMessage<GetCapturedImageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GetCapturedImageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "max_width", jsonName: "max_width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "max_height", jsonName: "max_height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "format", kind: "enum", T: proto3.getEnumType(CapturedImageFormat) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCapturedImageRequest {
    return new GetCapturedImageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCapturedImageRequest {
    return new GetCapturedImageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCapturedImageRequest {
    return new GetCapturedImageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCapturedImageRequest | PlainMessage<GetCapturedImageRequest> | undefined, b: GetCapturedImageRequest | PlainMessage<GetCapturedImageRequest> | undefined): boolean {
    return proto3.util.equals(GetCapturedImageRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.GetCapturedImageResponse
 */
export class GetCapturedImageResponse extends Message<GetCapturedImageResponse> {
  /**
   * @generated from field: bool found = 1;
   */
  found = false;

  /**
   * PNG or BMP bytes per format
   *
   * @generated from field: bytes image_data = 2 [json_name = "image_data"];
   */
  imageData = new Uint8Array(0);

  /**
   * @generated from field: int32 width = 3;
   */
  width = 0;

  /**
   * @generated from field: int32 height = 4;
   */
  height = 0;

  /**
   * error detail if found==false
   *
   * @generated from field: string reason = 5;
   */
  reason = "";

  /**
   * echoes what image_data contains
   *
   * @generated from field: cuda_learning.CapturedImageFormat format = 6;
   */
  format = CapturedImageFormat.UNSPECIFIED;

  constructor(data?: PartialMessage<GetCapturedImageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.GetCapturedImageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "found", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "image_data", jsonName: "image_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "format", kind: "enum", T: proto3.getEnumType(CapturedImageFormat) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCapturedImageResponse {
    return new GetCapturedImageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCapturedImageResponse {
    return new GetCapturedImageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCapturedImageResponse {
    return new GetCapturedImageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCapturedImageResponse | PlainMessage<GetCapturedImageResponse> | undefined, b: GetCapturedImageResponse | PlainMessage<GetCapturedImageResponse> | undefined): boolean {
    return proto3.util.equals(GetCapturedImageResponse, a, b);
  }
}

/**
 * DeleteCapturedImage removes a captured BMP file from disk.
 *
 * @generated from message cuda_learning.DeleteCapturedImageRequest
 */
export class DeleteCapturedImageRequest extends Message<DeleteCapturedImageRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteCapturedImageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.DeleteCapturedImageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCapturedImageRequest {
    return new DeleteCapturedImageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCapturedImageRequest {
    return new DeleteCapturedImageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCapturedImageRequest {
    return new DeleteCapturedImageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCapturedImageRequest | PlainMessage<DeleteCapturedImageRequest> | undefined, b: DeleteCapturedImageRequest | PlainMessage<DeleteCapturedImageRequest> | undefined): boolean {
    return proto3.util.equals(DeleteCapturedImageRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.DeleteCapturedImageResponse
 */
export class DeleteCapturedImageResponse extends Message<DeleteCapturedImageResponse> {
  /**
   * @generated from field: bool deleted = 1;
   */
  deleted = false;

  /**
   * error detail when deleted==false
   *
   * @generated from field: string reason = 2;
   */
  reason = "";

  constructor(data?: PartialMessage<DeleteCapturedImageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.DeleteCapturedImageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCapturedImageResponse {
    return new DeleteCapturedImageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCapturedImageResponse {
    return new DeleteCapturedImageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCapturedImageResponse {
    return new DeleteCapturedImageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCapturedImageResponse | PlainMessage<DeleteCapturedImageResponse> | undefined, b: DeleteCapturedImageResponse | PlainMessage<DeleteCapturedImageResponse> | undefined): boolean {
    return proto3.util.equals(DeleteCapturedImageResponse, a, b);
  }
}

